/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M21.5 42a20.5 20.5 0 1 0 0-41 20.5 20.5 0 0 0 0 41zm0-4a16.5 16.5 0 1 0 0-33 16.5 16.5 0 0 0 0 33z"/><path pid="1" d="M33.37 33.37a2 2 0 0 1 2.83 0l10.18 10.19a2 2 0 0 1-2.82 2.82L33.36 36.2a2 2 0 0 1 0-2.83z"/>'
  }
})
